// extracted by mini-css-extract-plugin
module.exports = {"Marker":"Marker_Marker__7eL3x","pin":"Marker_pin__2MIc3","draggable":"Marker_draggable__2Ds3I","dragging":"Marker_dragging__3LNF4","label":"Marker_label__3Me72"};